import React from "react";
import { HiArrowNarrowRight } from "react-icons/hi";
import { Link } from "react-scroll";

const Home = () => {
  return (
    <div name="home" className="w-full h-screen sm:pt-8 bg-[#0a192f] pt-10">
      {/* Container */}
      <div className="max-w-[1000px] mx-auto px-8 flex flex-col justify-center h-full">
        <p className="text-[#cd853f] mb-2">Oi, meu nome é</p>
        <h1 className="text-4xl sm:text-7xl font-bold text-[#ccd6f6] mb-2">
          Gabriel Paes Pinheiro
        </h1>
        <h2 className="text-4xl sm:text-7xl font-bold text-[#8892b0]">
          Sou programador
        </h2>
        <p className="text-[#8892b0] py-4 max-w-[700px]">
          Como programador full-stack sou especializado em entregar experiências excepcionais aos usuários. Atualmente estou focado em entregar páginas e aplicações responsivas e de fácil usabilidade aos usuários na internet.
        </p>
        <div>
          <button className="text-white border-2 border-[#cd853f] px-6 py-3 my-4 flex items-center hover:bg-[#cd853f] hover:text-[#0a192f] hover:border-[#0a192f]">
            <Link to="work" smooth={true} duration={500}>
              Ver projetos
            </Link>
            <span className="group-hover:rotate-90 duration-300">
              <HiArrowNarrowRight className="ml-3" />
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Home;
